import {select, call} from 'redux-saga/effects';
import config from '../../config';

const calculateSASDServiceProviderRouteDistance = function* calculateSASDServiceProviderRouteDistance(params) {
    const {serviceManager} = yield select(state => state.application);

    const {damage, destination, serviceProvider} = params;

    if (!destination?.latitude || !destination?.longitude) return;
    if (!damage?.location?.latitude || !damage?.location?.longitude) return;
    if (!serviceProvider?.location?.latitude || !serviceProvider?.location?.longitude) return;

    if (!config.IS_FALLBACK_SYSTEM) {
        const arcGISRESTService = serviceManager.loadService('arcGISRESTService');
        const response = yield call(
            arcGISRESTService.getMultipleStopsRoute,
            {
                stops: [
                    [damage.location.longitude, damage.location.latitude],
                    [destination.longitude, destination.latitude],
                    [serviceProvider.location.longitude, serviceProvider.location.latitude],
                ],
            },
        );

        const {arcGISRouteDTO} = response;
        serviceProvider.location.routeToReferentialPoint = arcGISRouteDTO;
        return;
    }

    const googleMapsService = serviceManager.loadService('googleMapsService');

    const response = yield call(
        googleMapsService.getRoute,
        {
            origin: {
                location: {
                    latLng: {
                        latitude: damage.location.latitude,
                        longitude: damage.location.longitude,
                    },
                },
            },
            destination: {
                location: {
                    latLng: {
                        latitude: serviceProvider.location.latitude,
                        longitude: serviceProvider.location.longitude,
                    },
                },
            },
            options: {
                intermediates: [
                    {
                        location: {
                            latLng: {
                                latitude: destination.latitude,
                                longitude: destination.longitude,
                            },
                        },
                    },
                ],
            },
            fields: ['routes.distanceMeters'],
        },
    );

    const route = response.routes[0];

    serviceProvider.location.routeToReferentialPoint = {
        totalKilometers: route?.distanceMeters / 1000 || null,
    };
};

export default calculateSASDServiceProviderRouteDistance;
